module.exports = __webpack_public_path__ + "img/logo.846cdfc0.png";